// msal.ts
import { PublicClientApplication } from '@azure/msal-browser';
import { getRuntimeConfig } from './config/runtimeConfig';
import { getMsalConfig } from './authConfig';

let instance: PublicClientApplication | null = null;

export function getMsalInstance(): PublicClientApplication {
  if (!instance) {
    const cfg = getRuntimeConfig();

    if (
      !cfg.VITE_AZURE_B2C_TENANT_NAME ||
      !cfg.VITE_AZURE_B2C_CLIENT_ID
    ) {
      throw new Error('Invalid MSAL runtime config');
    }

    instance = new PublicClientApplication(getMsalConfig(cfg));
  }

  return instance;
}
